import PropType, {string} from "prop-types";

export const WalletItemType = PropType.shape({
    id_item: PropType.any,
    prezzo: PropType.number, //Contiene il prezzo compreso di sconti
    totale: PropType.number, //Contiene l'importo che si andrà a pagare in quel momento, se è un acconto del 30% sarà 30% di prezzo (prop precedente)
    nome: PropType.string //Opzionale, solo per i package
})

//PER IL MODULO_HOTEL id_item: "id_camera:id_tariffa"